import { useMemo, useId } from 'react'
import * as React from 'react'
import RadioInput from 'LuxKit/Radio/RadioInput'
import useExperiencesSortOptions from '../hooks/useExperiencesSortOptions'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import { rem } from 'polished'

const SortOption = styled(RadioInput)`
  display: flex;
  width: 100%;
  padding-block: ${rem(1)};
  cursor: pointer;
  touch-action: manipulation;
`

function ExperiencesSortByOptions() {
  const { setSortBy, sortBy, sortOptions } = useExperiencesSortOptions()
  const groupId = useId()
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSortBy(e.target.value as Experiences.SortTypes)
  }
  const options = useMemo(() => Object.entries(sortOptions), [sortOptions])

  return (
    <Group direction="vertical" gap={16}>
      {options.map(([key, option]) => (
        <SortOption
          key={key}
          id={`experience-sort-by-${groupId}-${key}`}
          checked={key === sortBy}
          onChange={onChange}
          name={`experience-sort-by-${groupId}`}
          value={key}
        >
          {option.label}
        </SortOption>
      ))}
    </Group>
  )
}

export default ExperiencesSortByOptions
